import { connect } from 'react-redux';

import { loadDashboardHeaderInfo } from '../../actions/dashboardActions';
import DashboardView from '../../components/Dashboard/DashboardView.jsx';
import { verifyLoggedUser } from '../../utils/verifyUserLogged';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => ({
  verifyLoggedUser: () => {
    verifyLoggedUser();
  },
  loadDashboardHeaderInfo: () => dispatch(loadDashboardHeaderInfo()),
});

const DashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardView);

export default DashboardContainer;
